import { makeStyles } from "@material-ui/core"
import { colors } from "../../../utils/theme"

const useSafetyPlanStyles = makeStyles((theme) => ({
  planDetails: {
    display: "flex",
    padding: "18px",
    flexDirection: "column",
    borderRadius: "24px",
    background: colors.safetyPlan.background,
    marginTop: "16px",
    maxWidth: "600px",
  },
  planDetailsContainer: {
    padding: "12px 20px",
    display: "flex",
  },
  planContent: {
    display: "flex",
    padding: "32px",
    borderRadius: "24px",
    background: colors.safetyPlan.ash,
    maxWidth: "600px",
  },
  planText: {
    color: colors.neutral.denim,
    fontSize: "22px",
    fontWeight: 400,
    lineHeight: "28px",
  },
  planContainer: {
    display: "flex",
    width: "1400px",
    padding: "44px 32px",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
  },
  loadingContainer: {
    minHeight: 120,
    height: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing(2),
  },
}))

export default useSafetyPlanStyles
